/*
 * @Author: Jiajia Li
 * @Date: 2024-08-26 15:00:23
 * @LastEditTime: 2024-09-10 16:12:36
 * @Description:
 */

import React, { useState } from "react";
import Icons from "./Icons";
import { Link } from "react-router-dom";
import CustomRating from "./CustomRating"; // Import CustomRating
import "./ProductItem.css";
import WishListBtn from "./WishListBtn";

// Grace added:'showWishListIcon = true', wishlist icon will be shown by default
export default function ProductItem({ item = {}, showWishListIcon = true, starsAtBottom = false }) {

  const initialWishlistStatus =
    item.user_reviews && item.user_reviews.length > 0
      ? item.user_reviews[0].wishlist
      : false;

  const [wishlist, setWishlist] = useState(initialWishlistStatus);

  return (
    <div className="card border-0 h-100 product-list-item">
      <div className="position-relative">
        <img
          src={
            item.image
              ? item.image
              : "https://placehold.co/260x360/FFF/c2c2c2?text=No+Picture"
          }
          className="card-img-top rounded"
          alt={item.name}
        />
        {showWishListIcon &&
          <span className="wishlist-wrapper">
            <WishListBtn
              isAdd={wishlist}
              productId={item.id}
              onSuccess={() => setWishlist(!wishlist)}
            />
          </span>
        }

        {/* Conditionally render the rate-wrapper unless starsAtBottom is true */}
        {!starsAtBottom && (
          <span className="rate-wrapper">
            <Icons.Star />{" "}
            <span className="align-middle">
              {parseFloat(item.rate)} ({parseInt(item.rate_count) || 0})
            </span>
          </span>
        )}
      </div>
      <div className="card-body">
        <h6 className="card-title">{item.brand.name}</h6>
        <p className="card-text fs-7">{item.name}</p>
        {/* Conditionally render the star ratings under the description if starsAtBottom is true */}
        {starsAtBottom && (
          <div className="star-ratings">
            <CustomRating rate={parseFloat(item.rate)} size={32} />
            <span className="align-middle">
            </span>
          </div>
        )}
        <Link
          to={`/product-details/` + item.id}
          className="stretched-link"
        ></Link>
      </div>
    </div>
  );
}

